import { render, staticRenderFns } from "./BotStatementList.vue?vue&type=template&id=086de9c0"
import script from "./BotStatementList.vue?vue&type=script&lang=js"
export * from "./BotStatementList.vue?vue&type=script&lang=js"
import style0 from "./BotStatementList.vue?vue&type=style&index=0&id=086de9c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports